// Guardian AI Earnings Service Protocol Definitions
// Balance, withdrawals, payouts and Stripe Connect onboarding
//
// Version: v1

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/earnings/earnings.proto (package guardianai.v1.earnings, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/earnings/earnings.proto.
 */
export const file_guardianai_v1_earnings_earnings: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.earnings.GetEarningsBalanceRequest
 */
export type GetEarningsBalanceRequest = Message<"guardianai.v1.earnings.GetEarningsBalanceRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.earnings.GetEarningsBalanceRequest
 */
export type GetEarningsBalanceRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.earnings.GetEarningsBalanceRequest.
 * Use `create(GetEarningsBalanceRequestSchema)` to create a new message.
 */
export const GetEarningsBalanceRequestSchema: GenMessage<GetEarningsBalanceRequest, {jsonType: GetEarningsBalanceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 0);

/**
 * @generated from message guardianai.v1.earnings.EarningsBalanceResponse
 */
export type EarningsBalanceResponse = Message<"guardianai.v1.earnings.EarningsBalanceResponse"> & {
  /**
   * Available balance that can be withdrawn
   *
   * @generated from field: int64 available_cents = 1;
   */
  availableCents: bigint;

  /**
   * Pending balance (not yet cleared)
   *
   * @generated from field: int64 pending_cents = 2;
   */
  pendingCents: bigint;

  /**
   * Lifetime total earnings
   *
   * @generated from field: int64 lifetime_earnings_cents = 3;
   */
  lifetimeEarningsCents: bigint;

  /**
   * Currency code (e.g., "usd")
   *
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * Whether Stripe Connect account is set up
   *
   * @generated from field: bool payout_enabled = 5;
   */
  payoutEnabled: boolean;

  /**
   * Last updated timestamp
   *
   * @generated from field: int64 last_updated_at = 6;
   */
  lastUpdatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.earnings.EarningsBalanceResponse
 */
export type EarningsBalanceResponseJson = {
  /**
   * Available balance that can be withdrawn
   *
   * @generated from field: int64 available_cents = 1;
   */
  availableCents?: string;

  /**
   * Pending balance (not yet cleared)
   *
   * @generated from field: int64 pending_cents = 2;
   */
  pendingCents?: string;

  /**
   * Lifetime total earnings
   *
   * @generated from field: int64 lifetime_earnings_cents = 3;
   */
  lifetimeEarningsCents?: string;

  /**
   * Currency code (e.g., "usd")
   *
   * @generated from field: string currency = 4;
   */
  currency?: string;

  /**
   * Whether Stripe Connect account is set up
   *
   * @generated from field: bool payout_enabled = 5;
   */
  payoutEnabled?: boolean;

  /**
   * Last updated timestamp
   *
   * @generated from field: int64 last_updated_at = 6;
   */
  lastUpdatedAt?: string;
};

/**
 * Describes the message guardianai.v1.earnings.EarningsBalanceResponse.
 * Use `create(EarningsBalanceResponseSchema)` to create a new message.
 */
export const EarningsBalanceResponseSchema: GenMessage<EarningsBalanceResponse, {jsonType: EarningsBalanceResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 1);

/**
 * @generated from message guardianai.v1.earnings.GetEarningsHistoryRequest
 */
export type GetEarningsHistoryRequest = Message<"guardianai.v1.earnings.GetEarningsHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Filter by type: "all", "case_reward", "bounty", "referral", "commission"
   *
   * @generated from field: string earning_type = 2;
   */
  earningType: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;

  /**
   * Optional: filter by date range
   *
   * @generated from field: int64 start_date = 5;
   */
  startDate: bigint;

  /**
   * @generated from field: int64 end_date = 6;
   */
  endDate: bigint;
};

/**
 * @generated from message guardianai.v1.earnings.GetEarningsHistoryRequest
 */
export type GetEarningsHistoryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * Filter by type: "all", "case_reward", "bounty", "referral", "commission"
   *
   * @generated from field: string earning_type = 2;
   */
  earningType?: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset?: number;

  /**
   * Optional: filter by date range
   *
   * @generated from field: int64 start_date = 5;
   */
  startDate?: string;

  /**
   * @generated from field: int64 end_date = 6;
   */
  endDate?: string;
};

/**
 * Describes the message guardianai.v1.earnings.GetEarningsHistoryRequest.
 * Use `create(GetEarningsHistoryRequestSchema)` to create a new message.
 */
export const GetEarningsHistoryRequestSchema: GenMessage<GetEarningsHistoryRequest, {jsonType: GetEarningsHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 2);

/**
 * @generated from message guardianai.v1.earnings.EarningsHistoryResponse
 */
export type EarningsHistoryResponse = Message<"guardianai.v1.earnings.EarningsHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.earnings.EarningRecord earnings = 1;
   */
  earnings: EarningRecord[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.earnings.EarningsHistoryResponse
 */
export type EarningsHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.earnings.EarningRecord earnings = 1;
   */
  earnings?: EarningRecordJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.earnings.EarningsHistoryResponse.
 * Use `create(EarningsHistoryResponseSchema)` to create a new message.
 */
export const EarningsHistoryResponseSchema: GenMessage<EarningsHistoryResponse, {jsonType: EarningsHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 3);

/**
 * @generated from message guardianai.v1.earnings.EarningRecord
 */
export type EarningRecord = Message<"guardianai.v1.earnings.EarningRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * Type: "case_reward", "bounty", "referral", "commission", "bonus"
   *
   * @generated from field: string earning_type = 3;
   */
  earningType: string;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * Description of what this earning was for
   *
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * Reference ID (e.g., case_id, bounty_id)
   *
   * @generated from field: string reference_id = 7;
   */
  referenceId: string;

  /**
   * @generated from field: string reference_type = 8;
   */
  referenceType: string;

  /**
   * Status: "pending", "cleared", "paid_out", "cancelled"
   *
   * @generated from field: string status = 9;
   */
  status: string;

  /**
   * @generated from field: int64 created_at = 10;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 cleared_at = 11;
   */
  clearedAt: bigint;
};

/**
 * @generated from message guardianai.v1.earnings.EarningRecord
 */
export type EarningRecordJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * Type: "case_reward", "bounty", "referral", "commission", "bonus"
   *
   * @generated from field: string earning_type = 3;
   */
  earningType?: string;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 5;
   */
  currency?: string;

  /**
   * Description of what this earning was for
   *
   * @generated from field: string description = 6;
   */
  description?: string;

  /**
   * Reference ID (e.g., case_id, bounty_id)
   *
   * @generated from field: string reference_id = 7;
   */
  referenceId?: string;

  /**
   * @generated from field: string reference_type = 8;
   */
  referenceType?: string;

  /**
   * Status: "pending", "cleared", "paid_out", "cancelled"
   *
   * @generated from field: string status = 9;
   */
  status?: string;

  /**
   * @generated from field: int64 created_at = 10;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 cleared_at = 11;
   */
  clearedAt?: string;
};

/**
 * Describes the message guardianai.v1.earnings.EarningRecord.
 * Use `create(EarningRecordSchema)` to create a new message.
 */
export const EarningRecordSchema: GenMessage<EarningRecord, {jsonType: EarningRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 4);

/**
 * @generated from message guardianai.v1.earnings.RequestWithdrawalRequest
 */
export type RequestWithdrawalRequest = Message<"guardianai.v1.earnings.RequestWithdrawalRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Amount to withdraw in cents (0 = withdraw all available)
   *
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 3;
   */
  currency: string;
};

/**
 * @generated from message guardianai.v1.earnings.RequestWithdrawalRequest
 */
export type RequestWithdrawalRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * Amount to withdraw in cents (0 = withdraw all available)
   *
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 3;
   */
  currency?: string;
};

/**
 * Describes the message guardianai.v1.earnings.RequestWithdrawalRequest.
 * Use `create(RequestWithdrawalRequestSchema)` to create a new message.
 */
export const RequestWithdrawalRequestSchema: GenMessage<RequestWithdrawalRequest, {jsonType: RequestWithdrawalRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 5);

/**
 * @generated from message guardianai.v1.earnings.WithdrawalResponse
 */
export type WithdrawalResponse = Message<"guardianai.v1.earnings.WithdrawalResponse"> & {
  /**
   * @generated from field: string withdrawal_id = 1;
   */
  withdrawalId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * Status: "pending", "processing", "completed", "failed"
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * Estimated arrival date (unix timestamp)
   *
   * @generated from field: int64 estimated_arrival = 7;
   */
  estimatedArrival: bigint;
};

/**
 * @generated from message guardianai.v1.earnings.WithdrawalResponse
 */
export type WithdrawalResponseJson = {
  /**
   * @generated from field: string withdrawal_id = 1;
   */
  withdrawalId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 5;
   */
  currency?: string;

  /**
   * Status: "pending", "processing", "completed", "failed"
   *
   * @generated from field: string status = 6;
   */
  status?: string;

  /**
   * Estimated arrival date (unix timestamp)
   *
   * @generated from field: int64 estimated_arrival = 7;
   */
  estimatedArrival?: string;
};

/**
 * Describes the message guardianai.v1.earnings.WithdrawalResponse.
 * Use `create(WithdrawalResponseSchema)` to create a new message.
 */
export const WithdrawalResponseSchema: GenMessage<WithdrawalResponse, {jsonType: WithdrawalResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 6);

/**
 * @generated from message guardianai.v1.earnings.GetPayoutHistoryRequest
 */
export type GetPayoutHistoryRequest = Message<"guardianai.v1.earnings.GetPayoutHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * Optional status filter
   *
   * @generated from field: string status = 4;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.earnings.GetPayoutHistoryRequest
 */
export type GetPayoutHistoryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset?: number;

  /**
   * Optional status filter
   *
   * @generated from field: string status = 4;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.earnings.GetPayoutHistoryRequest.
 * Use `create(GetPayoutHistoryRequestSchema)` to create a new message.
 */
export const GetPayoutHistoryRequestSchema: GenMessage<GetPayoutHistoryRequest, {jsonType: GetPayoutHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 7);

/**
 * @generated from message guardianai.v1.earnings.PayoutHistoryResponse
 */
export type PayoutHistoryResponse = Message<"guardianai.v1.earnings.PayoutHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.earnings.PayoutRecord payouts = 1;
   */
  payouts: PayoutRecord[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.earnings.PayoutHistoryResponse
 */
export type PayoutHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.earnings.PayoutRecord payouts = 1;
   */
  payouts?: PayoutRecordJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.earnings.PayoutHistoryResponse.
 * Use `create(PayoutHistoryResponseSchema)` to create a new message.
 */
export const PayoutHistoryResponseSchema: GenMessage<PayoutHistoryResponse, {jsonType: PayoutHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 8);

/**
 * @generated from message guardianai.v1.earnings.PayoutRecord
 */
export type PayoutRecord = Message<"guardianai.v1.earnings.PayoutRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * Status: "pending", "in_transit", "paid", "failed", "cancelled"
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * Bank account last 4 digits
   *
   * @generated from field: string destination_last4 = 5;
   */
  destinationLast4: string;

  /**
   * @generated from field: int64 initiated_at = 6;
   */
  initiatedAt: bigint;

  /**
   * @generated from field: int64 arrival_date = 7;
   */
  arrivalDate: bigint;

  /**
   * @generated from field: string failure_reason = 8;
   */
  failureReason: string;
};

/**
 * @generated from message guardianai.v1.earnings.PayoutRecord
 */
export type PayoutRecordJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 3;
   */
  currency?: string;

  /**
   * Status: "pending", "in_transit", "paid", "failed", "cancelled"
   *
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * Bank account last 4 digits
   *
   * @generated from field: string destination_last4 = 5;
   */
  destinationLast4?: string;

  /**
   * @generated from field: int64 initiated_at = 6;
   */
  initiatedAt?: string;

  /**
   * @generated from field: int64 arrival_date = 7;
   */
  arrivalDate?: string;

  /**
   * @generated from field: string failure_reason = 8;
   */
  failureReason?: string;
};

/**
 * Describes the message guardianai.v1.earnings.PayoutRecord.
 * Use `create(PayoutRecordSchema)` to create a new message.
 */
export const PayoutRecordSchema: GenMessage<PayoutRecord, {jsonType: PayoutRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 9);

/**
 * @generated from message guardianai.v1.earnings.GetConnectOnboardingLinkRequest
 */
export type GetConnectOnboardingLinkRequest = Message<"guardianai.v1.earnings.GetConnectOnboardingLinkRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * URL to redirect back to after completion
   *
   * @generated from field: string return_url = 2;
   */
  returnUrl: string;

  /**
   * URL for if user needs to refresh/retry
   *
   * @generated from field: string refresh_url = 3;
   */
  refreshUrl: string;
};

/**
 * @generated from message guardianai.v1.earnings.GetConnectOnboardingLinkRequest
 */
export type GetConnectOnboardingLinkRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * URL to redirect back to after completion
   *
   * @generated from field: string return_url = 2;
   */
  returnUrl?: string;

  /**
   * URL for if user needs to refresh/retry
   *
   * @generated from field: string refresh_url = 3;
   */
  refreshUrl?: string;
};

/**
 * Describes the message guardianai.v1.earnings.GetConnectOnboardingLinkRequest.
 * Use `create(GetConnectOnboardingLinkRequestSchema)` to create a new message.
 */
export const GetConnectOnboardingLinkRequestSchema: GenMessage<GetConnectOnboardingLinkRequest, {jsonType: GetConnectOnboardingLinkRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 10);

/**
 * @generated from message guardianai.v1.earnings.ConnectOnboardingLinkResponse
 */
export type ConnectOnboardingLinkResponse = Message<"guardianai.v1.earnings.ConnectOnboardingLinkResponse"> & {
  /**
   * @generated from field: string onboarding_url = 1;
   */
  onboardingUrl: string;

  /**
   * When the link expires (unix timestamp)
   *
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.earnings.ConnectOnboardingLinkResponse
 */
export type ConnectOnboardingLinkResponseJson = {
  /**
   * @generated from field: string onboarding_url = 1;
   */
  onboardingUrl?: string;

  /**
   * When the link expires (unix timestamp)
   *
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.earnings.ConnectOnboardingLinkResponse.
 * Use `create(ConnectOnboardingLinkResponseSchema)` to create a new message.
 */
export const ConnectOnboardingLinkResponseSchema: GenMessage<ConnectOnboardingLinkResponse, {jsonType: ConnectOnboardingLinkResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 11);

/**
 * @generated from message guardianai.v1.earnings.GetConnectAccountStatusRequest
 */
export type GetConnectAccountStatusRequest = Message<"guardianai.v1.earnings.GetConnectAccountStatusRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.earnings.GetConnectAccountStatusRequest
 */
export type GetConnectAccountStatusRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.earnings.GetConnectAccountStatusRequest.
 * Use `create(GetConnectAccountStatusRequestSchema)` to create a new message.
 */
export const GetConnectAccountStatusRequestSchema: GenMessage<GetConnectAccountStatusRequest, {jsonType: GetConnectAccountStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 12);

/**
 * @generated from message guardianai.v1.earnings.RefreshConnectAccountStatusRequest
 */
export type RefreshConnectAccountStatusRequest = Message<"guardianai.v1.earnings.RefreshConnectAccountStatusRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.earnings.RefreshConnectAccountStatusRequest
 */
export type RefreshConnectAccountStatusRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.earnings.RefreshConnectAccountStatusRequest.
 * Use `create(RefreshConnectAccountStatusRequestSchema)` to create a new message.
 */
export const RefreshConnectAccountStatusRequestSchema: GenMessage<RefreshConnectAccountStatusRequest, {jsonType: RefreshConnectAccountStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 13);

/**
 * @generated from message guardianai.v1.earnings.ConnectAccountStatusResponse
 */
export type ConnectAccountStatusResponse = Message<"guardianai.v1.earnings.ConnectAccountStatusResponse"> & {
  /**
   * Whether user has a Stripe Connect account
   *
   * @generated from field: bool account_exists = 1;
   */
  accountExists: boolean;

  /**
   * Stripe Connect account ID (if exists)
   *
   * @generated from field: string stripe_account_id = 2;
   */
  stripeAccountId: string;

  /**
   * Whether account can receive charges
   *
   * @generated from field: bool charges_enabled = 3;
   */
  chargesEnabled: boolean;

  /**
   * Whether account can receive payouts
   *
   * @generated from field: bool payouts_enabled = 4;
   */
  payoutsEnabled: boolean;

  /**
   * Whether user has completed onboarding
   *
   * @generated from field: bool details_submitted = 5;
   */
  detailsSubmitted: boolean;

  /**
   * Account status: "pending", "active", "restricted", "disabled"
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * If restricted, why
   *
   * @generated from field: string restriction_reason = 7;
   */
  restrictionReason: string;

  /**
   * Email on the Stripe account
   *
   * @generated from field: string email = 8;
   */
  email: string;
};

/**
 * @generated from message guardianai.v1.earnings.ConnectAccountStatusResponse
 */
export type ConnectAccountStatusResponseJson = {
  /**
   * Whether user has a Stripe Connect account
   *
   * @generated from field: bool account_exists = 1;
   */
  accountExists?: boolean;

  /**
   * Stripe Connect account ID (if exists)
   *
   * @generated from field: string stripe_account_id = 2;
   */
  stripeAccountId?: string;

  /**
   * Whether account can receive charges
   *
   * @generated from field: bool charges_enabled = 3;
   */
  chargesEnabled?: boolean;

  /**
   * Whether account can receive payouts
   *
   * @generated from field: bool payouts_enabled = 4;
   */
  payoutsEnabled?: boolean;

  /**
   * Whether user has completed onboarding
   *
   * @generated from field: bool details_submitted = 5;
   */
  detailsSubmitted?: boolean;

  /**
   * Account status: "pending", "active", "restricted", "disabled"
   *
   * @generated from field: string status = 6;
   */
  status?: string;

  /**
   * If restricted, why
   *
   * @generated from field: string restriction_reason = 7;
   */
  restrictionReason?: string;

  /**
   * Email on the Stripe account
   *
   * @generated from field: string email = 8;
   */
  email?: string;
};

/**
 * Describes the message guardianai.v1.earnings.ConnectAccountStatusResponse.
 * Use `create(ConnectAccountStatusResponseSchema)` to create a new message.
 */
export const ConnectAccountStatusResponseSchema: GenMessage<ConnectAccountStatusResponse, {jsonType: ConnectAccountStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 14);

/**
 * @generated from message guardianai.v1.earnings.GetEarningsSummaryRequest
 */
export type GetEarningsSummaryRequest = Message<"guardianai.v1.earnings.GetEarningsSummaryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Period: "today", "week", "month", "year", "all_time"
   *
   * @generated from field: string period = 2;
   */
  period: string;
};

/**
 * @generated from message guardianai.v1.earnings.GetEarningsSummaryRequest
 */
export type GetEarningsSummaryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * Period: "today", "week", "month", "year", "all_time"
   *
   * @generated from field: string period = 2;
   */
  period?: string;
};

/**
 * Describes the message guardianai.v1.earnings.GetEarningsSummaryRequest.
 * Use `create(GetEarningsSummaryRequestSchema)` to create a new message.
 */
export const GetEarningsSummaryRequestSchema: GenMessage<GetEarningsSummaryRequest, {jsonType: GetEarningsSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 15);

/**
 * @generated from message guardianai.v1.earnings.EarningsSummaryResponse
 */
export type EarningsSummaryResponse = Message<"guardianai.v1.earnings.EarningsSummaryResponse"> & {
  /**
   * Total earnings for period
   *
   * @generated from field: int64 total_earnings_cents = 1;
   */
  totalEarningsCents: bigint;

  /**
   * Number of completed cases/tasks
   *
   * @generated from field: int32 tasks_completed = 2;
   */
  tasksCompleted: number;

  /**
   * Average earnings per task
   *
   * @generated from field: int64 avg_earning_per_task_cents = 3;
   */
  avgEarningPerTaskCents: bigint;

  /**
   * Top earning category
   *
   * @generated from field: string top_earning_type = 4;
   */
  topEarningType: string;

  /**
   * Breakdown by earning type
   *
   * @generated from field: repeated guardianai.v1.earnings.EarningBreakdown breakdowns = 5;
   */
  breakdowns: EarningBreakdown[];

  /**
   * Trend: percentage change from previous period
   *
   * @generated from field: double trend_percentage = 6;
   */
  trendPercentage: number;

  /**
   * Currency
   *
   * @generated from field: string currency = 7;
   */
  currency: string;
};

/**
 * @generated from message guardianai.v1.earnings.EarningsSummaryResponse
 */
export type EarningsSummaryResponseJson = {
  /**
   * Total earnings for period
   *
   * @generated from field: int64 total_earnings_cents = 1;
   */
  totalEarningsCents?: string;

  /**
   * Number of completed cases/tasks
   *
   * @generated from field: int32 tasks_completed = 2;
   */
  tasksCompleted?: number;

  /**
   * Average earnings per task
   *
   * @generated from field: int64 avg_earning_per_task_cents = 3;
   */
  avgEarningPerTaskCents?: string;

  /**
   * Top earning category
   *
   * @generated from field: string top_earning_type = 4;
   */
  topEarningType?: string;

  /**
   * Breakdown by earning type
   *
   * @generated from field: repeated guardianai.v1.earnings.EarningBreakdown breakdowns = 5;
   */
  breakdowns?: EarningBreakdownJson[];

  /**
   * Trend: percentage change from previous period
   *
   * @generated from field: double trend_percentage = 6;
   */
  trendPercentage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Currency
   *
   * @generated from field: string currency = 7;
   */
  currency?: string;
};

/**
 * Describes the message guardianai.v1.earnings.EarningsSummaryResponse.
 * Use `create(EarningsSummaryResponseSchema)` to create a new message.
 */
export const EarningsSummaryResponseSchema: GenMessage<EarningsSummaryResponse, {jsonType: EarningsSummaryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 16);

/**
 * @generated from message guardianai.v1.earnings.EarningBreakdown
 */
export type EarningBreakdown = Message<"guardianai.v1.earnings.EarningBreakdown"> & {
  /**
   * @generated from field: string earning_type = 1;
   */
  earningType: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * @generated from message guardianai.v1.earnings.EarningBreakdown
 */
export type EarningBreakdownJson = {
  /**
   * @generated from field: string earning_type = 1;
   */
  earningType?: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: int32 count = 3;
   */
  count?: number;
};

/**
 * Describes the message guardianai.v1.earnings.EarningBreakdown.
 * Use `create(EarningBreakdownSchema)` to create a new message.
 */
export const EarningBreakdownSchema: GenMessage<EarningBreakdown, {jsonType: EarningBreakdownJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_earnings_earnings, 17);

/**
 * Earnings Service - Balance, withdrawals, payouts for earners
 *
 * @generated from service guardianai.v1.earnings.EarningsService
 */
export const EarningsService: GenService<{
  /**
   * Get current earnings balance for user
   *
   * @generated from rpc guardianai.v1.earnings.EarningsService.GetEarningsBalance
   */
  getEarningsBalance: {
    methodKind: "unary";
    input: typeof GetEarningsBalanceRequestSchema;
    output: typeof EarningsBalanceResponseSchema;
  },
  /**
   * Get earnings history (completed cases, bounties, etc.)
   *
   * @generated from rpc guardianai.v1.earnings.EarningsService.GetEarningsHistory
   */
  getEarningsHistory: {
    methodKind: "unary";
    input: typeof GetEarningsHistoryRequestSchema;
    output: typeof EarningsHistoryResponseSchema;
  },
  /**
   * Request a withdrawal/payout
   *
   * @generated from rpc guardianai.v1.earnings.EarningsService.RequestWithdrawal
   */
  requestWithdrawal: {
    methodKind: "unary";
    input: typeof RequestWithdrawalRequestSchema;
    output: typeof WithdrawalResponseSchema;
  },
  /**
   * Get withdrawal/payout history
   *
   * @generated from rpc guardianai.v1.earnings.EarningsService.GetPayoutHistory
   */
  getPayoutHistory: {
    methodKind: "unary";
    input: typeof GetPayoutHistoryRequestSchema;
    output: typeof PayoutHistoryResponseSchema;
  },
  /**
   * Get Stripe Connect onboarding link
   *
   * @generated from rpc guardianai.v1.earnings.EarningsService.GetConnectOnboardingLink
   */
  getConnectOnboardingLink: {
    methodKind: "unary";
    input: typeof GetConnectOnboardingLinkRequestSchema;
    output: typeof ConnectOnboardingLinkResponseSchema;
  },
  /**
   * Get Stripe Connect account status
   *
   * @generated from rpc guardianai.v1.earnings.EarningsService.GetConnectAccountStatus
   */
  getConnectAccountStatus: {
    methodKind: "unary";
    input: typeof GetConnectAccountStatusRequestSchema;
    output: typeof ConnectAccountStatusResponseSchema;
  },
  /**
   * Refresh/update Stripe Connect account status from Stripe
   *
   * @generated from rpc guardianai.v1.earnings.EarningsService.RefreshConnectAccountStatus
   */
  refreshConnectAccountStatus: {
    methodKind: "unary";
    input: typeof RefreshConnectAccountStatusRequestSchema;
    output: typeof ConnectAccountStatusResponseSchema;
  },
  /**
   * Get earnings summary (for dashboard cards)
   *
   * @generated from rpc guardianai.v1.earnings.EarningsService.GetEarningsSummary
   */
  getEarningsSummary: {
    methodKind: "unary";
    input: typeof GetEarningsSummaryRequestSchema;
    output: typeof EarningsSummaryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_earnings_earnings, 0);

